export default {
  url: import.meta.env.VITE_API_URL,
  urlGraphQL: import.meta.env.VITE_GRAPHQL_URL || `${import.meta.env.VITE_API_URL}/graphql`,
  BASIC_AUTH: null,
  DEBUG: Number(import.meta.env.VITE_API_DEBUG) === 1,
}
